import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Overlaytext from "../components/Overlaytext/Overlaytext";
const ServicesPage = () => {
  return (
    <div className="App">
      <Header />

      {/* Hero Section */}
      <Overlaytext title="Our Core Services" subtitle="Comprehensive industrial solutions and technical services for your business needs" backgroundImage=" https://images.unsplash.com/photo-1758873268877-3cd8ed329ed8?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=3132 " />


      {/* Services Grid */}
      <section className="services-main">
        <div className="container">
          <div className="services-grid">
            <div className="service-card-detailed">
              <div className="service-icon">
                <img src="/Images/NewIcons/Machinery & Equipment Supply.png" alt="Machinery & Equipment Supply" />
              </div>
              <h3>Machinery & Equipment Supply</h3>
              <p>
                We provide a wide range of industrial, engineering, and educational machinery, covering workshop machines, fabrication equipment, construction machinery, and more.
              </p>
              <ul className="service-features">
                <li>Workshop Machines: Lathe, Milling, Drilling, Shaping, Grinding</li>
                <li>Fabrication & Welding Equipment</li>
                <li>Construction Machinery: Mixers, Vibrators, Compactors</li>
                <li>Electrical & Mechanical Laboratory Setups for ITIs</li>
                <li>Testing & Measuring Instruments</li>
                <li>CNC, Hydraulic, and Pneumatic Training Machines</li>
              </ul>
              <p className="service-note">All machines sourced from reputed manufacturers with proper warranty, calibration, and certification.</p>
            </div>

            <div className="service-card-detailed">
              <div className="service-icon">
                <img src="/Images/NewIcons/Fire & Safety Division.png" alt="Fire & Safety Division" />
              </div>
              <h3>Fire & Safety Division</h3>
              <p>
                Complete fire protection solutions from design to commissioning for factories, hospitals, commercial complexes, and government institutions.
              </p>
              <ul className="service-features">
                <li>Fire Alarm & Detection Systems</li>
                <li>Fire Hydrant and Sprinkler Systems</li>
                <li>Automatic Suppression Systems (CO₂, Foam, Clean Agent)</li>
                <li>Portable & Trolley-Mounted Fire Extinguishers</li>
                <li>Fire Hoses, Nozzles, and Safety Accessories</li>
                <li>Fire Safety Signages & Evacuation Maps</li>
                <li>AMC (Annual Maintenance Contracts) for Fire Systems</li>
                <li>System Testing, Refilling & Certification Services</li>
              </ul>
              <p className="service-note">All installations comply with NFPA, BIS, and NBC standards.</p>
            </div>

            <div className="service-card-detailed">
              <div className="service-icon">
                <img src="/Images/NewIcons/Government & Tender Supply.png" alt="Government & Tender Supply" />
              </div>
              <h3>Government & Tender Supply</h3>
              <p>
                Authorized and registered vendor for government departments and educational institutions with extensive experience in tender execution.
              </p>
              <ul className="service-features">
                <li>ITI & Polytechnic Institutes — complete workshop setups</li>
                <li>PWD / Municipal Departments — fire safety & equipment</li>
                <li>Educational Training Kits — hydraulic, pneumatic systems</li>
                <li>Defence / Police / Fire Departments — safety equipment</li>
                <li>Agriculture & Forest Departments — field tools</li>
                <li>Smart City Projects & Civic Utilities</li>
              </ul>
              <p className="service-note">Full compliance with tender requirements, specifications, and documentation.</p>
            </div>

            <div className="service-card-detailed">
              <div className="service-icon">
                <img src="/Images/NewIcons/Engineering & Technical Services.png" alt="Engineering & Technical Services" />
              </div>
              <h3>Engineering & Technical Services</h3>
              <p>
                We don't just supply — we design, install, and maintain. Comprehensive technical services with our professional engineering team.
              </p>
              <ul className="service-features">
                <li>Installation & Commissioning of Machines & Fire Systems</li>
                <li>Preventive and Breakdown Maintenance</li>
                <li>Calibration & Testing Services</li>
                <li>Site Layout Planning and Engineering Drawings</li>
                <li>Annual Maintenance Contracts (AMC)</li>
                <li>Training Programs for ITI and Technical Institutes</li>
                <li>Custom Fabrication & Panel Assembly Work</li>
                <li>Turnkey Project Execution</li>
              </ul>
              <p className="service-note">Our engineering team includes ITI, Diploma, and B.E. professionals trained for safety and reliability.</p>
            </div>

            <div className="service-card-detailed">
              <div className="service-icon">
                <img src="/Images/NewIcons/Retail & Wholesale Distribution.png" alt="Retail & Wholesale Distribution" />
              </div>
              <h3>Retail & Wholesale Distribution</h3>
              <p>
                Operating both retail and wholesale supply with competitive pricing, ready stock availability, and pan-India delivery.
              </p>
              <ul className="service-features">
                <li>Workshop Tools and Spare Parts</li>
                <li>Industrial Consumables</li>
                <li>Fire Safety Accessories & Equipment</li>
                <li>Lubricants, Bearings, Fasteners, and Belts</li>
                <li>Electric & Mechanical Components</li>
                <li>Safety PPE: Helmets, Gloves, Shoes, and Uniforms</li>
              </ul>
              <p className="service-note">Reliable logistics network ensuring pan-India delivery.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <div className="container">
          <h2>Our Process</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Discovery</h3>
              <p>
                We analyze your current sales processes and identify
                opportunities for improvement.
              </p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Strategy</h3>
              <p>
                We develop a customized strategy tailored to your business goals
                and market.
              </p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Implementation</h3>
              <p>
                We execute the strategy with your team, providing ongoing
                support and guidance.
              </p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Optimization</h3>
              <p>
                We continuously monitor and optimize performance to ensure
                maximum results.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-overlay"></div>
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>
              Contact us today to discuss your machinery, fire safety, or technical service requirements. We're here to provide comprehensive solutions for your business needs.
            </p>
            <div className="cta-buttons">
              <button className="btn btn-primary">Get Quote</button>
              <button className="btn btn-secondary">Contact Us</button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
